import React from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { Container } from "reactstrap"

//Import sections
import BillList from "./BillList"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const BillView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Bills | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Bills" breadcrumbItem="Manage Bills" />
          <BillList />
        </Container>
      </div>
    </React.Fragment>
  )
}

BillView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(BillView)
